var ezdia;
(function (ezdia) {
    var TEMPLATES = ezdia.templates.openProjects;
    var navActiveCls = 'active';
    function navbar() {
        var htmlContent = TEMPLATES.navHtml();
        $("#page-nav").replaceWith(htmlContent);
    }
    function resetStatusNavActive() {
        var items = $("#ez-js-status-nav").find('li').removeClass(navActiveCls);
        items.first().addClass(navActiveCls);
    }
    function markNavActive() {
        var parent = this.parentElement;
        if (parent.classList.contains(navActiveCls)) {
            return false;
        }
        parent.classList.add(navActiveCls);
        $(parent).siblings().removeClass(navActiveCls);
        return true;
    }
    function handelRoleNavClick(event) {
        return __awaiter(this, void 0, void 0, function () {
            var isNotActive, href;
            return __generator(this, function (_a) {
                event.preventDefault();
                isNotActive = markNavActive.call(this);
                if (!isNotActive) {
                    return [2 /*return*/];
                }
                href = this.href;
                window.location.href = href;
                return [2 /*return*/];
            });
        });
    }
    function fetchCards(status) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accountName, role, roleLabel, response, openProjectCards, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = ezdia.config.pageParams, accountName = _a.account, role = _a.role, roleLabel = _a.roleLabel;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ezdia.Http.post({
                                url: 'getOpenProjectCards.htm',
                                data: {
                                    accountName: accountName,
                                    role: role,
                                    roleLabel: roleLabel,
                                    status: status
                                }
                            })];
                    case 2:
                        response = _b.sent();
                        openProjectCards = response.open_project_cards;
                        ezdia.config.pageParams.openProjectCards = openProjectCards;
                        renderCard();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        console.error(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        ezdia.util.loading.disable();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateStatusQueryParams(status) {
        var url = new URL(window.location.href);
        var searchParams = url.searchParams;
        if (status) {
            searchParams.set('status', status);
        }
        else {
            searchParams.delete('status');
        }
        var newUrl = url.toString();
        // window.location.href = newUrl;
        window.history.pushState({}, '', newUrl);
    }
    function handelStatusNavClick() {
        var isNotActive = markNavActive.call(this);
        if (!isNotActive) {
            return;
        }
        ezdia.util.loading.enable();
        var status = this.dataset.status;
        updateStatusQueryParams(status);
        fetchCards(status);
    }
    function handelFavBtn() {
        var openProjectCards = ezdia.config.pageParams.openProjectCards;
        var actionFavorite = this.dataset.actionFavorite;
        var actionObj = openProjectCards.filter(function (_a) {
            var name = _a.name;
            return actionFavorite === name;
        });
        var _a = actionObj[0], name = _a.name, status = _a.status, accountName = _a.accountName, role = _a.role;
        var data = {
            accountName: accountName,
            role: role,
            status: status === 'starred' ? '' : 'starred',
            projInfoName: name
        };
        saveOpenProjUserPrefs(data);
    }
    function updateIcon(name, status) {
        var iconAddCls = 'ez-favorited';
        var iconRemoveCls = 'ez-favorite';
        if (status === '') {
            iconAddCls = 'ez-favorite';
            iconRemoveCls = 'ez-favorited';
        }
        var icon = $("[data-action-favorite=\"" + name + "\"]").find('.fa');
        icon.removeClass(iconRemoveCls);
        icon.addClass(iconAddCls);
    }
    function updateStatus(_a) {
        var e_1, _b;
        var status = _a.status, projInfoName = _a.projInfoName;
        var openProjectCards = ezdia.config.pageParams.openProjectCards;
        try {
            for (var openProjectCards_1 = __values(openProjectCards), openProjectCards_1_1 = openProjectCards_1.next(); !openProjectCards_1_1.done; openProjectCards_1_1 = openProjectCards_1.next()) {
                var proj = openProjectCards_1_1.value;
                var name_1 = proj.name;
                if (name_1 === projInfoName) {
                    proj.status = status;
                    updateIcon(name_1, status);
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (openProjectCards_1_1 && !openProjectCards_1_1.done && (_b = openProjectCards_1.return)) _b.call(openProjectCards_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    function saveOpenProjUserPrefs(data) {
        return __awaiter(this, void 0, void 0, function () {
            var message, ex_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, ezdia.Http.post({
                                url: 'SaveOpenProjPrefs.htm',
                                data: data
                            })];
                    case 1:
                        message = (_a.sent()).message;
                        ezdia.util.showSuccessError({
                            message: message
                        });
                        updateStatus(data);
                        return [3 /*break*/, 3];
                    case 2:
                        ex_1 = _a.sent();
                        ezdia.util.showSuccessError({
                            message: ex_1.message ||
                                'Unable to save the data this time.Please try again later.',
                            error: true
                        });
                        console.error(ex_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function events() {
        var roleNav = document.getElementById('ez-js-role-nav');
        var statusNav = document.getElementById('ez-js-status-nav');
        if (roleNav) {
            $(roleNav).find("a").on('click', handelRoleNavClick);
        }
        if (statusNav) {
            $(statusNav).find("a").on('click', handelStatusNavClick);
        }
        favBtnEvent();
    }
    function favBtnEvent() {
        var cradsWrapper = document.getElementById('ez-openProject-card-list');
        if (cradsWrapper) {
            $(cradsWrapper).on('click', 'a[data-action-favorite]', handelFavBtn);
        }
    }
    function renderCard(filterBy) {
        var _a = ezdia.config.pageParams, allRoles = _a.allRoles, openProjectCards = _a.openProjectCards;
        var cards = [];
        var htmlContent = "";
        if (filterBy) {
            cards = openProjectCards.filter(function (_a) {
                var status = _a.status;
                return filterBy === status;
            });
        }
        else {
            cards = openProjectCards;
        }
        if (allRoles) {
            if (cards && cards.length) {
                htmlContent = TEMPLATES.cardsHtml(cards);
            }
            else {
                htmlContent = TEMPLATES.noProjects();
            }
        }
        else {
            htmlContent = TEMPLATES.noProjects();
        }
        $("#page-contant").html(htmlContent);
        $('#ez-openProject-card-list').masonry({
            columnWidth: '.card-col',
            itemSelector: '.card-col'
        });
        favBtnEvent();
    }
    var OpenProjects = /** @class */ (function () {
        function OpenProjects() {
        }
        OpenProjects.prototype.render = function () {
            var allRoles = ezdia.config.pageParams.allRoles;
            if (allRoles) {
                navbar();
                renderCard();
            }
            else {
                var htmlContent = TEMPLATES.noProjects();
                $("#page-contant").html(htmlContent);
            }
            events();
            pageLoadingDone();
        };
        return OpenProjects;
    }());
    var pages;
    (function (pages) {
        pages.openProjects = new OpenProjects();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
